import React from 'react';
import './SocialLink.css';
import Badge from './Shared/Badge';
import { SocialLinks } from './Data';

function SocialLink() {
    return (
        <div className="pl-2 mt-4 social-link-badge-contents">
            <div className="header-text">
                <p className="h3"><b>Connect me at ⯆</b></p>
            </div>
            <div className="flex-wrap social-link-badge-list">
                {
                    SocialLinks.map((item) => (
                        <Badge key={item.key} openLink={item.openLink}
                            imageUrl={item.imageUrl}
                            displayText={item.displayText}
                        />
                    ))
                }
            </div>
        </div >
    );
}

export default SocialLink;